<ix-modal-header [requiredRoles]="requiredRoles" [title]="title" [loading]="isFormLoading"></ix-modal-header>
<mat-card>
  <mat-card-content>
    <form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
      <ix-fieldset>
        <ix-input
          formControlName="description"
          [label]="'Description' | translate"
          [required]="true"
        ></ix-input>
        <ix-input
          formControlName="mgmt_ip1"
          [label]="'IP' | translate"
          [required]="true"
          [tooltip]="'IP of 1st Redfish management interface.' | translate"
        ></ix-input>
        <ix-input
          formControlName="mgmt_ip2"
          [label]="'Optional IP' | translate"
          [tooltip]="'Optional IP of 2nd Redfish management interface.' | translate"
        ></ix-input>
        <ix-input
          formControlName="mgmt_username"
          [label]="'Username' | translate"
          [required]="true"
          [tooltip]="'Redfish administrative username.' | translate"
        ></ix-input>
        <ix-input
          formControlName="mgmt_password"
          type="password"
          [label]="'Password' | translate"
          [required]="true"
          [tooltip]="'Redfish administrative password.' | translate"
        ></ix-input>
      </ix-fieldset>

      <ix-form-actions>
        <button
          *ixRequiresRoles="requiredRoles"
          mat-button
          type="submit"
          color="primary"
          ixTest="save"
          [disabled]="form.invalid || isFormLoading"
        >
          {{ 'Save' | translate }}
        </button>
      </ix-form-actions>
    </form>
  </mat-card-content>
</mat-card>
